module.exports = __webpack_public_path__ + "static/media/icon_chengzheng_gray.730e1e0a.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/icon_chengzheng_gray.png
// module id = 2161
// module chunks = 0